import { copyObject } from "../../services";
import {
  DEFAULT_HEADERS,
  HEALTHCARE_CLASSES_OPTIONS,
  HOTEL_CLASSES_OPTIONS,
  STATES,
} from "../demo/constants";

const PreliminaryStageType = {
  hotels: "HOTELS",
  health: "HEALTH_CARE_CENTERS",
};

export const PreliminaryStageSolarForecast = {
  parking_lots: "INCLUDE_WITH_PARKING_LOTS",
  without_parking_lots: "INCLUDE_WITHOUT_PARKING_LOTS",
  exclude: "EXCLUDE",
};

const BASE_INFO_HEADERS = [
  ...DEFAULT_HEADERS.slice(0, 3),
  { key: "state", text: "State", minWidth: 150, selectOptions: STATES },
  ...DEFAULT_HEADERS.slice(3, 5),
];

const ELECTRICITY_HEADERS = DEFAULT_HEADERS.slice(11);

const PHOTOVOLTAIC_OUTPUT = {
  key: "photovoltaic_power_output",
  text: "Annual photovoltaic power output (kWh/Kwp)",
  minWidth: 200,
  type: "number",
};

const SOLAR_ROOF = [
  {
    key: "roof_eic",
    text: "Roof - Estimated Installed Capacity (kWp) (Preliminary estimate)",
    minWidth: 200,
    type: "number",
  },
  {
    key: "roof_aep",
    text: "Roof - Annual Electricity Production (kWh/Year)",
    minWidth: 200,
    type: "number",
  },
];

const SOLAR_PARKING_LOTS = [
  {
    key: "parking_lots_eic",
    text: "Parking Lots - Estimated Installed Capacity (kWp) (Preliminary estimate)",
    minWidth: 200,
    type: "number",
  },
  {
    key: "parking_lots_aep",
    text: "Parking Lots - Annual Electricity Production (kWh/Year)",
    minWidth: 200,
    type: "number",
  },
];

const PARKING_LOTS = {
  key: "parking_lots_square",
  text: "Parking Lots Area (Outdoor Parking)",
  minWidth: 100,
  type: "number",
};

const SOLAR_OWN_HOTEL_HEADERS = [
  ...BASE_INFO_HEADERS,
  {
    key: "hotel_classes",
    text: "Hotel classes",
    minWidth: 100,
    selectOptions: HOTEL_CLASSES_OPTIONS,
  },
  ...DEFAULT_HEADERS.slice(5, 7),
  PARKING_LOTS,
  DEFAULT_HEADERS[7],
  DEFAULT_HEADERS[9],
  ...ELECTRICITY_HEADERS,
];

const SOLAR_OWN_HEALTHCARE_HEADERS = [
  ...BASE_INFO_HEADERS,
  {
    key: "healthcare_classes",
    text: "HealthCare center classes",
    minWidth: 100,
    selectOptions: HEALTHCARE_CLASSES_OPTIONS,
  },
  ...DEFAULT_HEADERS.slice(5, 7),
  PARKING_LOTS,
  DEFAULT_HEADERS[7],
  DEFAULT_HEADERS[9],
  ...ELECTRICITY_HEADERS,
];

const SOLAR_OWN_HEADERS = [
  ...BASE_INFO_HEADERS,
  ...DEFAULT_HEADERS.slice(5, 7),
  PARKING_LOTS,
  DEFAULT_HEADERS[7],
  DEFAULT_HEADERS[9],
  ...ELECTRICITY_HEADERS,
];

const WITHOUT_SOLAR_OWN_HOTEL_HEADERS = [
  ...BASE_INFO_HEADERS,
  {
    key: "hotel_classes",
    text: "Hotel classes",
    minWidth: 100,
    selectOptions: HOTEL_CLASSES_OPTIONS,
  },
  ...DEFAULT_HEADERS.slice(5, 7),
  DEFAULT_HEADERS[7],
  DEFAULT_HEADERS[9],
  ...ELECTRICITY_HEADERS,
];

const WITHOUT_SOLAR_OWN_HEALTHCARE_HEADERS = [
  ...BASE_INFO_HEADERS,
  {
    key: "healthcare_classes",
    text: "HealthCare center classes",
    minWidth: 100,
    selectOptions: HEALTHCARE_CLASSES_OPTIONS,
  },
  ...DEFAULT_HEADERS.slice(5, 7),
  DEFAULT_HEADERS[7],
  DEFAULT_HEADERS[9],
  ...ELECTRICITY_HEADERS,
];

const WITHOUT_SOLAR_OWN_HEADERS = [
  ...BASE_INFO_HEADERS,
  ...DEFAULT_HEADERS.slice(5, 7),
  DEFAULT_HEADERS[7],
  DEFAULT_HEADERS[9],
  ...ELECTRICITY_HEADERS,
];

const SOLAR_TENANTS_HEADERS = [
  ...BASE_INFO_HEADERS,
  ...DEFAULT_HEADERS.slice(5, 7),
  PARKING_LOTS,
  ...DEFAULT_HEADERS.slice(7, 11),
  ...ELECTRICITY_HEADERS,
];

const WITHOUT_SOLAR_TENANTS_HEADERS = [...BASE_INFO_HEADERS, ...DEFAULT_HEADERS.slice(5)];

export const getTableHeaders = (preliminaryStage) => {
  if (preliminaryStage.owner === "OWN_CONSUMPTION") {
    if (preliminaryStage.solar_forecast === PreliminaryStageSolarForecast.parking_lots) {
      if (preliminaryStage.flexible_category) {
        if (preliminaryStage.type === PreliminaryStageType.hotels) {
          return SOLAR_OWN_HOTEL_HEADERS;
        } else if (preliminaryStage.type === PreliminaryStageType.health) {
          return SOLAR_OWN_HEALTHCARE_HEADERS;
        }
      }
      return SOLAR_OWN_HEADERS;
    } else {
      if (preliminaryStage.flexible_category) {
        if (preliminaryStage.type === PreliminaryStageType.hotels) {
          return WITHOUT_SOLAR_OWN_HOTEL_HEADERS;
        } else if (preliminaryStage.type === PreliminaryStageType.health) {
          return WITHOUT_SOLAR_OWN_HEALTHCARE_HEADERS;
        }
      }
      return WITHOUT_SOLAR_OWN_HEADERS;
    }
  } else {
    if (preliminaryStage.solar_forecast === PreliminaryStageSolarForecast.parking_lots) {
      return SOLAR_TENANTS_HEADERS;
    }
    return WITHOUT_SOLAR_TENANTS_HEADERS;
  }
};

export const appendSolarColumns = (preliminaryStage, headers) => {
  if (Object.values(PreliminaryStageSolarForecast).includes(preliminaryStage.solar_forecast)) {
    const tempHeaders = copyObject(headers);
    tempHeaders.splice(6, 0, PHOTOVOLTAIC_OUTPUT);
    const zipCodeIndex = tempHeaders.findIndex((header) => header.key === "area_type");

    if (preliminaryStage.solar_forecast === PreliminaryStageSolarForecast.without_parking_lots) {
      tempHeaders.splice(zipCodeIndex + 1, 0, ...SOLAR_ROOF);
    } else if (preliminaryStage.solar_forecast === PreliminaryStageSolarForecast.parking_lots) {
      tempHeaders.splice(zipCodeIndex + 1, 0, ...[...SOLAR_ROOF, ...SOLAR_PARKING_LOTS]);
    }

    return tempHeaders;
  }

  return headers;
};
